module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/blue arrow-0df6d830.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/blue arrow.svg
// module id = ./app/web/src/assets/blue arrow.svg
// module chunks = 0